module.exports = __webpack_public_path__ + "img/uz.b1a9372.svg";